import type { ReactNode, MouseEvent } from 'react';
import ChevronDownIcon from '@/assets/images/chevron-down.svg';

type DetailsDisplayProps = {
  children?: ReactNode;
  /** Chevron shown closed; it rotates rather than being swapped when open. */
  openIconURL?: string;
  summaryClasses?: string;
  detailsClasses?: string;
  contentClasses?: string;
  summaryContent: ReactNode;
  isOpen?: boolean;
  handleToggle?: (e: MouseEvent<HTMLDetailsElement>) => void;
};

export const DetailsDisplay = ({
  openIconURL,
  summaryContent,
  children,
  isOpen,
  handleToggle,
  summaryClasses = '',
  detailsClasses = '',
  contentClasses = '',
}: DetailsDisplayProps) => {
  return (
    <details
      // `group` lets the chevron follow the native open state, which matters
      // because not every caller drives `isOpen` itself.
      className={`group bg-white p-4 rounded-[14px] ${detailsClasses}`}
      open={isOpen}
    >
      <summary
        className={`gift-summary-toggle flex cursor-pointer items-center justify-between gap-2.5 font-bold text-left ${summaryClasses}`}
        onClick={handleToggle}
      >
        <span>{summaryContent}</span>
        <img
          src={openIconURL || ChevronDownIcon}
          alt=''
          aria-hidden='true'
          className='img-fluid shrink-0 transition-transform duration-200 group-open:rotate-180'
        />
      </summary>
      <div className={`${contentClasses}`}>{children}</div>
    </details>
  );
}
